// intro
import { useHistory } from 'react-router-dom';

import ButtonActionsLink from './button-actions';

import { Row, Col } from 'antd';

export default function IntroActionsModule () {

  return (
  <>
    <div className={``} >

      <Row className="" >
        
        <Col xs={0} md={7} lg={9}></Col>

        <Col xs={24} md={10} lg={6}>
        <ButtonActionsLink data={{link: '/auth/mail', text:'Early Access', icon: 'bx bx-bolt-circle', backcolor:'back-color-wite', textcolor: 'text-color-main'}} />      
        </Col>

        <Col xs={0} md={7} lg={9}></Col>
        
      </Row>


    </div>
  </>

  )
}